import * as React from 'react';
import * as firebase from 'firebase/app';
import { reduxForm, Field, InjectedFormProps } from 'redux-form';
import { Dispatch, connect } from 'react-redux';
import { AppState, Merchant } from 'src/store';
import { SelectField, TextField } from 'redux-form-antd';
import { actions as toast } from 'src/toast';
import { Button, Card, Row, Col } from 'antd';
import { push } from 'react-router-redux';
import { RouteComponentProps } from 'react-router';
import { required } from 'src/reduxFormAntd/validations';
import { actions } from '../redux';
import { Subscription } from 'rxjs';
import { querySnapShot$ } from 'src/util';

const formItemLayout = {
    labelCol: {
        xs: { span: 12 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 15 },
    },
};

const mapStateToProps = (appState: AppState, props: Props) => {
    const { featuredAdsDetailState } = appState;
    const { match: { params: { id } } } = props;
    let initialValues: Partial<FormData> = { name: '' };
    if (id && featuredAdsDetailState.status === 'loaded') {
        const {
            name,
            merchants
        } = featuredAdsDetailState.data;
        const merchantIds: string[] = [];
        if (merchants && merchants.length > 0) {
            merchants.forEach((merchant) => {
                merchantIds.push(merchant.id)
            })
        }
        initialValues = { name, merchantIds };
    }
    const loading = (featuredAdsDetailState.status === 'loading');
    return {
        id,
        initialValues,
        loading,
    };
};
const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        listen: (id: string | null) => {
            if (id) {
                dispatch(actions.listenDoc(id));
            }
        },
        unlisten: () => {
            dispatch(actions.unlistenDoc());
        }
    };
};

interface FormData {
    id?: string;
    name: string;
    merchantIds: string[];
}

interface Props extends InjectedFormProps<FormData>, RouteComponentProps<{ id: string | null }> {
    id: string | null;
    loading: boolean;
    // merchantsState: CollectionState<Merchant>;
    listen: (id: string | null) => void;
    unlisten: () => void;
    filter?: (cv: Merchant) => boolean;
}
type S = {
    status: 'none' | 'loading';
} | {
    status: 'loaded';
    merchants: Merchant[];
}

const defaultFilter = () => true;

const filterOptionFunc = (input: string, option: object) =>
    // tslint:disable-next-line:no-any
    (option as any).props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

class CreateOrEditFeaturedAds extends React.Component<Props, S> {
    subscription: Subscription;

    constructor(props: Props) {
        super(props);
        this.state = { status: 'none' };
        this.subscription = new Subscription();
    }

    componentDidMount() {
        const { id, listen } = this.props;
        this.setState({ status: 'loading' });
        const query = firebase.firestore().collection('merchants')
            .where('discover.status', '==', 'Published');

        this.subscription = querySnapShot$(query)
            .subscribe(qsn => {
                const merchants = qsn.docs.map(d => ({ id: d.id, ...d.data() } as Merchant));
                this.setState({ status: 'loaded', merchants });
            });
        listen(id);

    }

    componentWillUnmount() {
        const { unlisten } = this.props;
        unlisten();
    }

    delete = async (values: FormData, dispatch: Dispatch<AppState>) => {
        const { id } = this.props;
        const ref = firebase.firestore().collection('featuredAds');
        if (id) {
            const doc = ref.doc(id)
            await doc.delete()
            dispatch(toast.success('FeaturedAds is deleted successfully.'));
            dispatch(push('/featuredAds'));
        }
    }

    submit = async ({ id, ...values }: FormData, dispatch: Dispatch<AppState>) => {
        const allMerchant = this.state.status === 'loaded' ? this.state.merchants : [];
        const merchants: Merchant[] = []
        let merchant: Merchant | undefined;
        if (values.merchantIds.length > 0) {
            values.merchantIds.forEach((merchantId) => {
                merchant = allMerchant.find(m => m.id === merchantId);
                if (merchant) {
                    merchants.push(merchant)
                }
            })
        }

        const addFeaturedAds = firebase.functions().httpsCallable('addFeaturedAds');
        await addFeaturedAds({
            id: id || this.props.id,
            ...values,
            merchants
        });
        dispatch(toast.success('FeaturedAds is added successfully.'));
        dispatch(push('/featuredAds'));
    }

    render() {
        const { handleSubmit, submitting, loading, id, filter } = this.props;
        const merchants = this.state.status === 'loaded' ? this.state.merchants : [];
        const filterFunc = filter || defaultFilter;
        const options = merchants.filter(filterFunc).map(m => ({
            label: m.businessName,
            value: m.id,
        }));

        return (
            <Card
                loading={loading}
                title={`${id ? 'Edit' : 'Create'} FeaturedAds`}
                bordered={true}
                bodyStyle={{ padding: 0 }}
            >
                <form onSubmit={handleSubmit(this.submit)} className="ant-form ant-form-horizontal code-box">
                    <section className="last">
                        <Row>
                            <Col span={12}>
                                <Field
                                    allowClear={true}
                                    showSearch={true}
                                    mode="multiple"
                                    name="merchantIds"
                                    label="Merchants"
                                    {...formItemLayout}
                                    options={options}
                                    filterOption={filterOptionFunc}
                                    component={SelectField}
                                    placeholder="Select Merchants"
                                    validate={[required]}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Field
                                    name="name"
                                    label="Name"
                                    {...formItemLayout}
                                    component={TextField}
                                    placeholder="Ads name"
                                    validate={[required]}
                                />
                            </Col>
                        </Row>
                    </section>
                    <section className="action-panel">
                        <Button type="primary" htmlType="submit" loading={submitting} icon="save">Save</Button>
                    </section>
                </form>
            </Card>
        );
    }
}

// tslint:disable-next-line:no-any
const F: any = reduxForm<FormData>({
    form: 'createOrEditFeaturedAds',
    enableReinitialize: true,
})(CreateOrEditFeaturedAds);
export default connect(mapStateToProps, mapDispatchToProps)(F);



// WEBPACK FOOTER //
// ./src/featuredAds/forms/CreateOrEditFeaturedAds.tsx